import { useEffect, useState } from "react";
import { launchError } from "components/notifications";
import { fetchSwissNotice } from "services/fetchUserById";
import './userSwissNotice.css'

const SOURCE_LABELS = {
  search: 'Own internet search',
  referral: 'Friend or family recommendation',
  other: 'Other'
}

const formatDeclaredAt = (declared_at) => new Date(declared_at).toLocaleString('en-GB', {
  timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
}) + ' UTC'

// Reverse solicitation declaration of clients residing in Switzerland: nothing is shown for the other clients
const UserSwissNotice = ({ user, id }) => {

  const [swissNotice, setSwissNotice] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchSwissNotice(user, id)
      .then(data => { if (!cancelled) setSwissNotice(data) })
      .catch((error) => console.error('swiss notice', error?.response?.status));
    return () => { cancelled = true };
  }, [user, id]);

  // The pre-signed URL expires after a few minutes: ask for a fresh one on every click
  const downloadPdf = async () => {
    try {
      const data = await fetchSwissNotice(user, id);
      setSwissNotice(data);
      if (data?.pdf_url)
        window.open(data.pdf_url, '_blank', 'noopener');
    } catch (error) {
      launchError('Unable to download the Swiss notice PDF')
    }
  }

  if (!swissNotice) return null;

  return <div className='user_swiss_notice_main_div'>
    <p className='user_swiss_notice_title'>Swiss notice :</p>
    <div className='user_swiss_notice_column'>
      <p className='user_swiss_notice_item'><span className='user_swiss_notice_label'>Date of declaration : </span>{formatDeclaredAt(swissNotice.declared_at)}</p>
      <p className='user_swiss_notice_item'><span className='user_swiss_notice_label'>How the client heard about us : </span>{SOURCE_LABELS[swissNotice.source] || swissNotice.source}</p>
      <p className='user_swiss_notice_item'><span className='user_swiss_notice_label'>Language displayed : </span>{swissNotice.language?.toUpperCase()}</p>
    </div>
    {swissNotice.pdf_status === 'done' && <div>
      <button className='user_action_button' onClick={downloadPdf}>Download PDF</button>
    </div>}
    {swissNotice.pdf_status === 'pending' && <p className='user_swiss_notice_status'>PDF being generated</p>}
    {swissNotice.pdf_status === 'failed' && <p className='user_swiss_notice_status user_swiss_notice_status_error'>PDF generation failed, contact the tech team</p>}
  </div>
}

export default UserSwissNotice
